import { Box, Paper, Tab, Tabs, Typography } from "@mui/material"
import Layout from "../components/Layout"
import VideoPlayer from "../components/VideoPlayer"
import { useState } from "react";
import { Container } from '../components/Container';

export const Configurations = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (


        <Layout >
            <Box marginBottom='10px'>
                <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                    Configurações
                </Typography>
            </Box>
            <Container>
                <Box marginBottom="20px">
                    <Tabs value={value} onChange={handleChange} aria-label="config-tabs" variant="scrollable" scrollButtons="auto" >
                        <Tab label="Player de Vídeo" />
                        <Tab label="Configurações do Sistema" />
                    </Tabs>
                </Box>
                {value === 0 && (
                    <Box marginTop="2">
                        <VideoPlayer />
                    </Box>
                )}

                {value === 1 && (
                    <Box sx={{ marginTop: 2 }}>
                        <Typography variant="h6" gutterBottom>
                            Configurações do Sistema
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            Configurações gerais do sistema serão implementadas aqui.
                        </Typography>
                    </Box>
                )}
            </Container>
        </Layout>
    )
}